module.exports = __webpack_public_path__ + "img/permission-preview.7947c190.jpg";